/* Free shipping bar */
(function () {
  function getMoneyFormat() {
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat;
    }

    if (window.theme && window.theme.strings && window.theme.strings.moneyFormat) {
      return window.theme.strings.moneyFormat;
    }

    return '€{{amount}}';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, getMoneyFormat());
    }

    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateFreeShippingBars(cart) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');

    if (!bars.length || !cart) return;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      var progressEl = bar.querySelector('[data-free-shipping-progress]');
      var textEl = bar.querySelector('[data-free-shipping-text]');

      if (!threshold || !progressEl || !textEl) return;

      var cartTotal = cart.total_price || 0;
      var left = threshold - cartTotal;

      if (left < 0) {
        left = 0;
      }

      var progress = Math.round((cartTotal / threshold) * 100);

      if (progress > 100) {
        progress = 100;
      }

      progressEl.style.width = progress + '%';

      if (cartTotal >= threshold) {
        textEl.textContent = bar.getAttribute('data-success-text') || 'Jums galioja nemokamas siuntimas!';
      } else {
        var bottomText = bar.getAttribute('data-bottom-text') || 'Liko iki nemokamo pristatymo {left}';
        textEl.textContent = bottomText.replace('{left}', formatMoney(left));
      }
    });
  }

  function fetchCartAndUpdateFreeShippingBars() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateFreeShippingBars(cart);
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', fetchCartAndUpdateFreeShippingBars);

  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart) {
      updateFreeShippingBars(event.detail.cart);
    } else {
      fetchCartAndUpdateFreeShippingBars();
    }
  });

  document.addEventListener('ajaxProduct:added', fetchCartAndUpdateFreeShippingBars);
  document.addEventListener('cart:refresh', fetchCartAndUpdateFreeShippingBars);

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || !form.matches('form[action*="/cart/add"]')) return;

    setTimeout(fetchCartAndUpdateFreeShippingBars, 700);
    setTimeout(fetchCartAndUpdateFreeShippingBars, 1400);
  });

  if (window.jQuery) {
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (!settings || !settings.url) return;

      var url = settings.url;

      if (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      ) {
        fetchCartAndUpdateFreeShippingBars();
      }
    });
  }

  var originalFetch = window.fetch;

  if (originalFetch) {
    window.fetch = function () {
      var fetchArguments = arguments;
      var fetchUrl = fetchArguments[0];

      var url = '';

      if (typeof fetchUrl === 'string') {
        url = fetchUrl;
      } else if (fetchUrl && fetchUrl.url) {
        url = fetchUrl.url;
      }

      return originalFetch.apply(this, fetchArguments).then(function (response) {
        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1 ||
          url.indexOf('/cart/clear') !== -1
        ) {
          setTimeout(fetchCartAndUpdateFreeShippingBars, 300);
        }

        return response;
      });
    };
  }
})();

/* Complementary add-on products */
(function () {
  window.themeComplementaryAddedItems = window.themeComplementaryAddedItems || [];

  function getSelectedComplementaryItems() {
    var selectedItems = [];
    var complementaryItems = document.querySelectorAll('[data-complementary-item]');

    complementaryItems.forEach(function (item) {
      var checkbox = item.querySelector('[data-complementary-checkbox]');
      var quantityInput = item.querySelector('[data-complementary-qty-input]');
      var variantId = item.getAttribute('data-variant-id');

      if (!checkbox || !checkbox.checked || !variantId) return;

      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      selectedItems.push({
        id: Number(variantId),
        quantity: quantity
      });
    });

    return selectedItems;
  }

  function formatComplementaryMoney(cents) {
    if (
      window.theme &&
      window.theme.Shopify &&
      typeof window.theme.Shopify.formatMoney === 'function'
    ) {
      return window.theme.Shopify.formatMoney(
        cents,
        window.theme.moneyFormat || window.theme.moneyFormatWithCodeForCartPreference
      );
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, '€{{amount}}');
    }

    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function addComplementaryItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw error;
        });
      }

      return response.json();
    });
  }

  function triggerNativeThemeSubmit(form) {
    form.setAttribute('data-complementary-skip', 'true');

    if (window.jQuery) {
      window.jQuery(form).trigger('submit');
    } else {
      form.dispatchEvent(new Event('submit', {
        bubbles: true,
        cancelable: true
      }));
    }

    setTimeout(function () {
      form.removeAttribute('data-complementary-skip');
    }, 1000);
  }

  function buildComplementaryNoticeProduct(item) {
    var image = item.image || '';
    var title = item.product_title || item.title || '';
    var variantTitle = item.variant_title || '';
    var quantity = item.quantity || 1;
    var linePrice = item.final_line_price || item.line_price || item.original_line_price || (item.price * quantity);

    var quantityHtml = quantity > 1
      ? ' <span class="cart-summary__quantity">' + quantity + '</span>'
      : '';

    var variantHtml = '';

    if (variantTitle && variantTitle !== 'Default Title') {
      variantHtml =
        '<div class="cart-summary__product__variants">' +
          '<div class="cart-summary__variant">' +
            '<span class="cart-summary__variant-value">' + escapeHtml(variantTitle) + '</span>' +
          '</div>' +
        '</div>';
    }

    return [
      '<div class="cart-summary__product cart-summary__product--complementary">',
        '<div class="cart-summary__product-image">',
          image
            ? '<img class="global-border-radius" src="' + escapeHtml(image) + '" role="presentation" alt="">'
            : '',
        '</div>',
        '<div class="cart-summary__product__description">',
          '<div class="cart-summary__product-title">',
            escapeHtml(title),
            quantityHtml,
          '</div>',
          variantHtml,
          '<div class="cart-summary__price">',
            '<span class="theme-money">',
              formatComplementaryMoney(linePrice),
            '</span>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');
  }

  function injectComplementaryItemsIntoAddedNotice() {
    var items = window.themeComplementaryAddedItems || [];

    if (!items.length) return;

    var notices = document.querySelectorAll('.added-notice:not([data-complementary-injected])');

    notices.forEach(function (notice) {
      var cartSummary = notice.querySelector('.cart-summary');

      if (!cartSummary) return;

      var firstProduct = cartSummary.querySelector('.cart-summary__product');

      if (!firstProduct) return;

      notice.setAttribute('data-complementary-injected', 'true');

      items.forEach(function (item) {
        firstProduct.insertAdjacentHTML('afterend', buildComplementaryNoticeProduct(item));
      });

      window.themeComplementaryAddedItems = [];
    });
  }

  function scheduleAddedNoticeInjection() {
    setTimeout(injectComplementaryItemsIntoAddedNotice, 100);
    setTimeout(injectComplementaryItemsIntoAddedNotice, 250);
    setTimeout(injectComplementaryItemsIntoAddedNotice, 500);
    setTimeout(injectComplementaryItemsIntoAddedNotice, 900);
    setTimeout(injectComplementaryItemsIntoAddedNotice, 1300);
  }

  document.addEventListener('click', function (event) {
    var minusButton = event.target.closest('[data-complementary-qty-minus]');
    var plusButton = event.target.closest('[data-complementary-qty-plus]');

    if (!minusButton && !plusButton) return;

    var quantityWrapper = event.target.closest('[data-complementary-quantity]');
    if (!quantityWrapper) return;

    var quantityInput = quantityWrapper.querySelector('[data-complementary-qty-input]');
    if (!quantityInput) return;

    var currentValue = parseInt(quantityInput.value, 10);

    if (!currentValue || currentValue < 1) {
      currentValue = 1;
    }

    if (plusButton) {
      currentValue += 1;
    }

    if (minusButton) {
      currentValue -= 1;
    }

    if (currentValue < 1) {
      currentValue = 1;
    }

    quantityInput.value = currentValue;
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form || !form.matches('form.ajax-product-form[action*="/cart/add"]')) {
      return;
    }

    if (form.getAttribute('data-complementary-skip') === 'true') {
      return;
    }

    var complementaryItems = getSelectedComplementaryItems();

    if (!complementaryItems.length) {
      window.themeComplementaryAddedItems = [];
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var submitButton = form.querySelector('[type="submit"][name="add"], [data-add-to-cart]');

    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
    }

    addComplementaryItems(complementaryItems)
      .then(function (response) {
        window.themeComplementaryAddedItems = response && response.items ? response.items : [];
        triggerNativeThemeSubmit(form);
        scheduleAddedNoticeInjection();
      })
      .catch(function (error) {
        console.error('Complementary products add-to-cart error:', error);

        window.themeComplementaryAddedItems = [];

        if (submitButton) {
          submitButton.removeAttribute('disabled');
        }

        if (
          window.theme &&
          typeof window.theme.showQuickPopup === 'function' &&
          window.jQuery
        ) {
          var message = error && error.description
            ? error.description
            : 'Nepavyko pridėti papildomų produktų į krepšelį.';

          window.theme.showQuickPopup(message, window.jQuery(submitButton));
        }
      });
  }, true);
})();

/* Custom Buy Now with complementary products */
(function () {
  function getSelectedComplementaryItems() {
    var selectedItems = [];
    var complementaryItems = document.querySelectorAll('[data-complementary-item]');

    complementaryItems.forEach(function (item) {
      var checkbox = item.querySelector('[data-complementary-checkbox]');
      var quantityInput = item.querySelector('[data-complementary-qty-input]');
      var variantId = item.getAttribute('data-variant-id');

      if (!checkbox || !checkbox.checked || !variantId) return;

      var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      selectedItems.push({
        id: Number(variantId),
        quantity: quantity
      });
    });

    return selectedItems;
  }

  function getMainProductForm(button) {
    if (!button) return null;

    return button.closest('form[action*="/cart/add"]');
  }

  function getMainProductVariantId(form) {
    var variantInput = form.querySelector('[name="id"]');

    if (!variantInput) return null;

    return variantInput.value;
  }

  function getMainProductQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!quantityInput) return 1;

    var quantity = parseInt(quantityInput.value, 10);

    if (!quantity || quantity < 1) {
      quantity = 1;
    }

    return quantity;
  }

  function addItemsToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (error) {
          throw error;
        });
      }

      return response.json();
    });
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('disabled');
      button.classList.remove('is-loading');
    }
  }

  function setupCustomQuickBuyButtons() {
    var hasComplementaryProducts = document.querySelector('[data-custom-complementary-products]');

    var customButtons = document.querySelectorAll('[data-custom-buy-now]');

    customButtons.forEach(function (customButton) {
      var form = getMainProductForm(customButton);
      var paymentButtonsWrapper = form ? form.querySelector('.shopify-payment-button') : null;

      if (hasComplementaryProducts) {
        if (paymentButtonsWrapper) {
          paymentButtonsWrapper.style.display = 'none';
        }

        customButton.style.display = '';
      } else {
        customButton.style.display = 'none';

        if (paymentButtonsWrapper) {
          paymentButtonsWrapper.style.display = '';
        }
      }
    });
  }

  document.addEventListener('DOMContentLoaded', setupCustomQuickBuyButtons);

  document.addEventListener('shopify:section:load', setupCustomQuickBuyButtons);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-custom-buy-now]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var form = getMainProductForm(button);

    if (!form) return;

    var mainVariantId = getMainProductVariantId(form);

    if (!mainVariantId) return;

    var items = [
      {
        id: Number(mainVariantId),
        quantity: getMainProductQuantity(form)
      }
    ].concat(getSelectedComplementaryItems());

    setButtonLoading(button, true);

    addItemsToCart(items)
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Custom quick buy error:', error);

        setButtonLoading(button, false);

        if (
          window.theme &&
          typeof window.theme.showQuickPopup === 'function' &&
          window.jQuery
        ) {
          var message = error && error.description
            ? error.description
            : 'Nepavyko pridėti produktų į krepšelį.';

          window.theme.showQuickPopup(message, window.jQuery(button));
        }
      });
  });
})();

/* Sticky product add-to-cart bar */
(function () {
  function formatMoney(cents) {
    var moneyFormat = '€{{amount}}';

    if (window.theme && window.theme.moneyFormat) {
      moneyFormat = window.theme.moneyFormat;
    } else if (window.theme && window.theme.moneyFormatWithCodeForCartPreference) {
      moneyFormat = window.theme.moneyFormatWithCodeForCartPreference;
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function getProductJson() {
    var productJsonEl = document.querySelector('[data-product-json]');

    if (!productJsonEl) return null;

    try {
      return JSON.parse(productJsonEl.textContent);
    } catch (error) {
      return null;
    }
  }

  function getCurrentVariant(productJson, form) {
    if (!productJson || !form) return null;

    var idInput = form.querySelector('[name="id"]');

    if (!idInput) return null;

    var selectedId = String(idInput.value);

    return productJson.variants.find(function (variant) {
      return String(variant.id) === selectedId;
    });
  }

  function updateStickyProductBar(bar, productJson, form) {
    var variant = getCurrentVariant(productJson, form);

    if (!variant) return;

    var priceEl = bar.querySelector('[data-sticky-product-price]');
    var comparePriceWrap = bar.querySelector('[data-sticky-product-compare-price-wrap]');
    var comparePriceEl = bar.querySelector('[data-sticky-product-compare-price]');
    var button = bar.querySelector('[data-sticky-product-add]');
    var buttonText = bar.querySelector('[data-sticky-product-add-text]');
    var imageEl = bar.querySelector('[data-sticky-product-image]');

    if (priceEl) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (comparePriceWrap && comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceWrap.classList.remove('visually-hidden');
      } else {
        comparePriceWrap.classList.add('visually-hidden');
      }
    }

    if (button) {
      if (variant.available) {
        button.removeAttribute('disabled');

        if (buttonText) {
          buttonText.textContent = bar.getAttribute('data-add-text') || buttonText.textContent;
        }
      } else {
        button.setAttribute('disabled', 'disabled');

        if (buttonText) {
          buttonText.textContent = bar.getAttribute('data-sold-out-text') || buttonText.textContent;
        }
      }
    }

    if (imageEl && variant.featured_image && variant.featured_image.src) {
      imageEl.src = variant.featured_image.src.replace(/(\.[^.]*)$/, '_160x$1');
    }
  }

  function initStickyProductBar() {
    var bar = document.querySelector('[data-sticky-product-bar]');

    if (!bar) return;

    var formId = bar.getAttribute('data-product-form-id');
    var form = formId ? document.getElementById(formId) : document.querySelector('form[action*="/cart/add"]');

    if (!form) return;

    var addButton = form.querySelector('[data-add-to-cart], button[name="add"]');

    if (!addButton) return;

    var productJson = getProductJson();

    bar.setAttribute('data-add-text', bar.querySelector('[data-sticky-product-add-text]') ? bar.querySelector('[data-sticky-product-add-text]').textContent.trim() : '');
    bar.setAttribute('data-sold-out-text', document.documentElement.lang ? '' : '');

    function updateVisibility() {
      var rect = addButton.getBoundingClientRect();
      var shouldShow = rect.bottom < 0;

      bar.classList.toggle('is-visible', shouldShow);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();

    form.addEventListener('change', function () {
      setTimeout(function () {
        updateStickyProductBar(bar, productJson, form);
      }, 50);
    });

    document.addEventListener('change', function (event) {
      if (!form.contains(event.target)) return;

      setTimeout(function () {
        updateStickyProductBar(bar, productJson, form);
      }, 50);
    });

    var stickyButton = bar.querySelector('[data-sticky-product-add]');

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        if (stickyButton.disabled || stickyButton.classList.contains('is-loading')) return;

        stickyButton.classList.add('is-loading');
        stickyButton.setAttribute('disabled', 'disabled');

        addButton.click();

        setTimeout(function () {
          stickyButton.classList.remove('is-loading');

          if (!addButton.disabled) {
            stickyButton.removeAttribute('disabled');
          }
        }, 1200);
      });
    }

    setInterval(function () {
      updateStickyProductBar(bar, productJson, form);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyProductBar);
  } else {
    initStickyProductBar();
  }

  document.addEventListener('shopify:section:load', initStickyProductBar);
})();